const colors = {
  // common
  black: '#000000',
  white: '#ffffff',
  // greys
  greyB2: '#B2B2B2',
  greyAA: '#AAAAAA',
  // colors
  yellowPale: '#FFFFBF',
  brown: '#735101',
  coral: '#FFD4CC',
  bordeaux: '#660000',
  orangeLight: '#FFDEBF',
  tobacco: '#733800',
  greenLight: '#CAFEE4', // '#C9FFE4',
  greenForest: '#00664C',
  blueLight: '#CBF2FF',
  blueNight: '#000066',
  lavender: '#DDCCFF',
  eggplant: '#440066',
  error: '#B00000',
}

export default colors
